import React, { useEffect, useState } from "react";

import { callApi } from "../components/common/Apis";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../components/actions/types";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { history } from "../components/utils";
import { authActions } from "../components/store";

export default function SignIn() {
    const dispatch = useDispatch();
    const authUser = useSelector((x) => x.auth.user);
    const authError = useSelector((x) => x.auth.error);

    const [loginState, setLoginState] = useState({
        inputId: "",
        inputPassword: "",
        idPlaceHolder: "",
        pwPlaceHolder: "",
        systemTit: "",
    });

    useEffect(() => {
        // redirect to home if already logged in
        if (authUser) history.navigate("/");
        setPlaceHolder();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setPlaceHolder = () => {
        var lang = localStorage.getItem("language");
        if (lang === "en") {
            setLoginState({
                systemTit: "Hanwha In-game Tactic Solution<br/>(H.I.T.S)",
                idPlaceHolder: "Please Enter your ID...",
                pwPlaceHolder: "Please Enter your Pasword...",
            });
        } else {
            setLoginState({
                systemTit: "모바일 영상조회 시스템",
                idPlaceHolder: "ID를 입력하세요.",
                pwPlaceHolder: "Password를 입력하세요.",
            });
        }
    };

    const loginSchema = Yup.object().shape({
        inputId: Yup.string().required("ID is required"),
        inputPassword: Yup.string().required("PW is required"),
    });

    const formOptions = {
        resolver: yupResolver(loginSchema),
    };

    const { register, handleSubmit, formState } = useForm(formOptions);
    const { errors, isSubmitting } = formState;

    function onSubmit({ inputId, inputPassword }) {
        return dispatch(
            authActions.login({ username: inputId, password: inputPassword })
        );
    }

    return (
        <div className="container">
            {/* Outer Row */}
            <div
                id="loginContainer"
                className="row justify-content-center"
                style={{ paddingTop: "100px" }}
            >
                <div className="col-xl-6 col-lg-8 col-md-9">
                    <div className="card o-hidden border-0 shadow-lg my-5">
                        <div className="card-body p-0">
                            {/* Nested Row within Card Body */}
                            <div className="row">
                                {/* <div
                                    className="col-lg-5 d-none d-lg-block"
                                    style={{
                                        background: "url(h_logo.png)",
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "center",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                ></div> */}
                                <div>
                                    <div className="p-5">
                                        <div className="text-center">
                                            <img
                                                width="150"
                                                alt="main_logo"
                                                // src="main_logo.png"
                                                src="logo_hiball.png"
                                                style={{
                                                    marginBottom: "20px",
                                                }}
                                            />
                                            <br></br>
                                            <h1
                                                id="systemTit"
                                                name="systemTit"
                                                className="h3 text-gray-900 mb-4"
                                            >
                                                {loginState.systemTit
                                                    .split("<br/>")
                                                    .map((line) => {
                                                        return (
                                                            <span key={line}>
                                                                {line}
                                                                <br />
                                                            </span>
                                                        );
                                                    })}
                                            </h1>
                                        </div>
                                        <form
                                            className="user"
                                            onSubmit={handleSubmit(onSubmit)}
                                        >
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    name="inputId"
                                                    {...register("inputId")}
                                                    className={`form-control ${
                                                        errors.inputId
                                                            ? "is-invalid"
                                                            : ""
                                                    }`}
                                                    placeholder={
                                                        loginState.idPlaceHolder
                                                    }
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="password"
                                                    name="inputPassword"
                                                    {...register(
                                                        "inputPassword"
                                                    )}
                                                    className={`form-control ${
                                                        errors.inputPassword
                                                            ? "is-valid"
                                                            : ""
                                                    }`}
                                                    placeholder={
                                                        loginState.pwPlaceHolder
                                                    }
                                                    autoComplete="off"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <div className="custom-control custom-checkbox small"></div>
                                            </div>
                                            <button
                                                id="loginBtn"
                                                disabled={isSubmitting}
                                                className="btn btn-block"
                                            >
                                                {isSubmitting && (
                                                    <span className="spinner-border spinner-border-sm mr-1"></span>
                                                )}
                                                LOGIN
                                            </button>
                                            {authError && (
                                                <div className="alert alert-danger mt-3 mb-0">
                                                    {authError.message}
                                                </div>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
